import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jpx-93-simplified-time-tracking');
	},
};
